import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import Popup from '../../../components/Popup/Popup';
import appConfig from '../../../config/appConfig';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {amplitudeScreensTracking} from '../../../services/amplitude';
import analyticsService from '../../../services/analyticsService';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import modalService from '../../../services/modalService';
import {selectIsDeviceReady, selectIsHolderConnected} from '../../../state/selectors/iotDevice';
import PauseModeCarousel from './components/PauseModeCarousel';

const PauseModePopup = ({modalType}) => {
    const localizedStrings = getLocalizedStrings();
    const isHolderConnected = useSelector(selectIsHolderConnected);
    const isClosePauseModePopup = appConfig.getIsClosePauseModePopup();
    const isDeviceReady = useSelector(selectIsDeviceReady);

    useEffect(() => {
        analyticsService.pushUsageSettingsPauseModeGuideEvent();
        amplitudeScreensTracking.trackPauseModeGuideViewed();
    }, []);

    useEffect(() => {
        if (isHolderConnected && isClosePauseModePopup) {
            modalService.hideModal(modalType);
        }
    }, [isHolderConnected, isClosePauseModePopup]);

    useEffect(() => {
        if (!isDeviceReady && isClosePauseModePopup) {
            modalService.hideModal(modalType);
        }
    }, [isDeviceReady, isClosePauseModePopup]);

    const onClose = () => {
        modalService.hideModal(modalType);
    };

    return (
        <Popup
            contentLabel={localizedStrings[localizationKeys.DEVICE_SETTINGS_PAUSE_MODE_TITLE]}
            className='bottom-2 left-2 w-[calc(100%_-_16px)] rounded-[32px] p-8 pt-16 md:left-1/2 md:max-w-[544px] md:p-16 md:pb-8'
            closeButtonAriaLabel={localizedStrings[localizationKeys.DEVICE_SETTINGS_PAUSE_MODE_BTN_CANCEL_ARIA_LABEL]}
            onClose={onClose}
            isCloseVisible
        >
            <PauseModeCarousel />
        </Popup>
    );
};

export default PauseModePopup;
